// extracted by mini-css-extract-plugin
export var bottomContent = "Insights-module--bottomContent--bfd08";
export var container = "Insights-module--container--77d33";
export var dark = "Insights-module--dark--9da5d";
export var description = "Insights-module--description--f66bd";
export var fadeInAnimation = "Insights-module--fadeInAnimation--79450";
export var link = "Insights-module--link--7c0d4";
export var linkRow = "Insights-module--linkRow--d6174";
export var wrapper = "Insights-module--wrapper--6be5d";